import CTASection from './home/CTASection';

const VALUES = [
  { icon: '⚽', title: 'Community First',      desc: 'Football is a community sport. We build tools that strengthen communities, not replace them.' },
  { icon: '🌍', title: 'Built for Expats',     desc: '88.5% of UAE residents are expats. We built Hadafi because we understand the challenge of finding your people in a new country.' },
  { icon: '🆓', title: 'Free Access',          desc: 'Access to football shouldn\'t depend on your wallet. Hadafi is 100% free, forever.' },
  { icon: '🔮', title: 'Pathways to Pro',      desc: 'We start with organizing. But we\'re building something bigger—pathways from street to stadium.' },
];

const ROADMAP = [
  { label: 'Scout partnerships & performance insights',     soon: true  },
  { label: 'Verified skill ratings by certified coaches',  soon: true  },
  { label: 'Pathways to professional football clubs',      soon: true  },
  { label: 'Regional tournaments & leagues',              soon: false },
  { label: 'Advanced match analytics & heat maps',        soon: false },
];

export default function AboutPage() {
  return (
    <div style={{ paddingTop: 68 }}>

      {/* ── HERO ── */}
      <section style={{
        padding: '6rem clamp(1rem,4vw,3rem) 5rem',
        background: 'linear-gradient(to bottom,var(--navy2),var(--navy))',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          background: 'radial-gradient(ellipse at 60% 40%, rgba(232,96,74,0.08) 0%, transparent 60%)',
        }} />
        <div style={{ maxWidth: 800, margin: '0 auto', position: 'relative' }}>
          <span className="section-tag">ABOUT HADAFI</span>
          <h1 className="section-title" style={{ fontSize: 'clamp(48px,7vw,80px)', marginBottom: '2rem' }}>
            Built By Players,<br /><span>For Players.</span>
          </h1>
          <p style={{ fontSize: 18, color: 'var(--muted)', lineHeight: 1.8, maxWidth: 600, fontWeight: 300 }}>
            Hadafi started with a simple frustration: organizing a football game in Dubai shouldn't require 47 WhatsApp messages and a group spreadsheet.
          </p>
        </div>
      </section>

      {/* ── STORY ── */}
      <section style={{ padding: '5rem clamp(1rem,4vw,3rem)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: '4rem', alignItems: 'start' }}>
            <div style={{ borderTop: '3px solid var(--coral)', paddingTop: '1rem' }}>
              <span className="section-tag" style={{ marginBottom: 0 }}>THE STORY</span>
            </div>
            <div className="vis">
              <h2 style={{ fontFamily: 'var(--font-d)', fontSize: 32, fontWeight: 800, textTransform: 'uppercase', marginBottom: '1.5rem' }}>
                Why We Built This
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
                {[
                  'The UAE has one of the most passionate football communities in the world. Thousands of players—students, expats, weekend warriors—who love the game but struggle with the same problem: organizing it.',
                  'Group chats fill up. Messages get buried. People cancel last minute. Games fall apart. And the talent? It goes completely unseen.',
                  null, // special quote paragraph
                  'We built Hadafi to change that. Starting with the boring stuff—organizing games—because that\'s what gets in the way. One link. One tap. Everyone\'s in.',
                  'But we\'re building toward something bigger. A platform where your performance data follows you. Where scouts can actually see talent. Where the path from street to stadium is a real path, not just a dream.',
                ].map((p, i) =>
                  p === null ? (
                    <p key={i} style={{ color: 'var(--white)', fontWeight: 500, fontSize: 16, lineHeight: 1.85, borderLeft: '3px solid var(--coral)', paddingLeft: '1rem' }}>
                      "88.5% of UAE residents are expats. Most never get scouted—not because they're not good enough, but because scouts don't watch neighborhood games."
                    </p>
                  ) : (
                    <p key={i} style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.85 }}>{p}</p>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section style={{ padding: '5rem clamp(1rem,4vw,3rem)', background: 'var(--navy2)' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <div className="vis" style={{ marginBottom: '3rem' }}>
            <span className="section-tag">WHAT WE STAND FOR</span>
            <h2 className="section-title" style={{ fontSize: 'clamp(32px,4vw,48px)' }}>Our Values</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '2rem' }}>
            {VALUES.map((v, i) => (
              <div key={i} className="vis card-hover" style={{
                border: '1px solid rgba(232,96,74,0.15)', borderRadius: 8,
                padding: '2rem', background: 'var(--navy)',
                transition: 'border-color 0.2s, transform 0.3s, box-shadow 0.3s',
              }}>
                <div style={{ fontSize: 28, marginBottom: '1rem' }}>{v.icon}</div>
                <h3 style={{ fontFamily: 'var(--font-d)', fontSize: 20, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1, marginBottom: '0.75rem' }}>{v.title}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.7 }}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ROADMAP ── */}
      <section style={{ padding: '5rem clamp(1rem,4vw,3rem)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: '4rem', alignItems: 'start' }}>
            <div style={{ borderTop: '3px solid var(--coral)', paddingTop: '1rem' }}>
              <span className="section-tag" style={{ marginBottom: 0 }}>WHAT'S NEXT</span>
            </div>
            <div className="vis">
              <h2 style={{ fontFamily: 'var(--font-d)', fontSize: 32, fontWeight: 800, textTransform: 'uppercase', marginBottom: '1.5rem' }}>
                The Roadmap
              </h2>
              {ROADMAP.map((item, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: '1rem',
                  padding: '1rem 0',
                  borderBottom: '1px solid rgba(122,155,181,0.1)',
                }}>
                  <div style={{
                    width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                    background: item.soon ? 'var(--coral)' : 'var(--slate)',
                  }} />
                  <p style={{ color: item.soon ? 'var(--muted)' : 'var(--slate)', fontSize: 15, flex: 1 }}>
                    {item.label}
                  </p>
                  {item.soon && (
                    <span style={{
                      fontFamily: 'var(--font-m)', fontSize: 10, color: 'var(--coral)',
                      background: 'rgba(232,96,74,0.1)', padding: '3px 8px', borderRadius: 2,
                    }}>SOON</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section style={{ padding: '4rem clamp(1rem,4vw,3rem)', background: 'var(--navy2)', textAlign: 'center' }}>
        <span className="section-tag" style={{ display: 'block' }}>GET IN TOUCH</span>
        <h2 className="vis section-title" style={{ fontSize: 40, marginBottom: '1rem' }}>Follow The Journey</h2>
        <p style={{ color: 'var(--muted)', marginBottom: '1.5rem' }}>
          Follow us at <strong style={{ color: 'var(--coral)' }}>hadafi.ae</strong> — join the community changing how football is played in the UAE.
        </p>
        <a href="mailto:hello@hadafi.ae" style={{
          color: 'var(--coral)', fontFamily: 'var(--font-m)', fontSize: 14,
          textDecoration: 'none', borderBottom: '1px solid rgba(232,96,74,0.3)',
        }}>hello@hadafi.ae</a>
      </section>

      <CTASection />
    </div>
  );
}
